import React from "react";
import { Link } from "react-router-dom";

const About = () => {
  return (
    <>
      <div className="container">
        <div id="top1" className="row">
          <div id="top1right" className="col-md-12 col-sm-12 col-xs-12 my-3">
            <h2>About Us</h2>
          </div>
        </div>
      </div>
      <div className="region region-content">
        <div id="block-system-main" className="block block-system">
          <div className="content">
            <div id="node-10002" className="node node-panel clearfix">
              <div className="content">
                <div className="container">
                  <div id="top1" className="row">
                    <div
                      id="top1right"
                      className="col-md-12 col-sm-12 col-xs-12"
                    >
                      <div className="panel-pane pane-node-body">
                        <div className="pane-content">
                          <div className="field field-name-body field-type-text-with-summary field-label-hidden">
                            <div className="field-items">
                              <div className="field-item even">
                                <p>
                                  <strong>Arabia Weddings</strong>&nbsp;is the
                                  MENA region's leading Online Wedding Planning
                                  Platform. Its rich content, comprehensive
                                  online directories of the wedding industry
                                  in&nbsp;16 Arab countries, wedding planning
                                  tools&nbsp;&amp; lots more… make it the
                                  must-visit digital platform connecting brides
                                  and grooms-to-be with the
                                  wedding&nbsp;industry in the Middle East and
                                  North Africa (MENA) region.&nbsp;
                                </p>
                                <p>
                                  <strong>For Wedding Vendors:&nbsp;</strong>
                                </p>
                                <p>
                                  We provide you with a marketplace to connect
                                  with brides and grooms-to-be in&nbsp;efficient
                                  and effective ways to receive Sales Leads and
                                  direct inquiries from them. We offer you great
                                  marketing opportunities through &nbsp;to reach
                                  out to a much wider audience.&nbsp;
                                </p>
                                <p>
                                  Your dashboard on Arabia Weddings will help
                                  you to monitor the Sales Leads and connect
                                  with couples effortlessly.&nbsp;
                                </p>

                                <p>
                                  <strong>For Engaged Couples:&nbsp;</strong>
                                </p>
                                <p>
                                  For brides and grooms-to-be, we facilitate the
                                  process of booking your wedding venue and
                                  other wedding suppliers. Just let us know{" "}
                                  <Link to="/getoffers" target="_blank">
                                    what you're looking for
                                  </Link>{" "}
                                  and we'll take it on from there. We also offer
                                  you a lot&nbsp;of inspiration and ideas
                                  on&nbsp;everything related to weddings
                                  -&nbsp;from fashion, to photography, flowers,
                                  cakes... and more, you'll find great tips,
                                  advice&nbsp;to inspire you.
                                </p>
                                <p>
                                  You'll be able to search for your local
                                  wedding venues and suppliers and connect with
                                  them easily through our{" "}
                                  <Link to="/" target="_blank">
                                    comprehensive directories
                                  </Link>
                                  .&nbsp;&nbsp;Using&nbsp;our{" "}
                                  <Link to="/weddingpakages/Manama">
                                    Wedding Planning Checklist
                                  </Link>
                                  &nbsp;and&nbsp;
                                  <Link to="/inspiration/Honeymoon?id=20">
                                    Honeymoon Packing List
                                  </Link>
                                  &nbsp;your wedding planning process will
                                  definitely become less stressful and more
                                  efficient. See inspiration from our{" "}
                                </p>
                                <hr />
                                <p>
                                  Keeping up with the trends worldwide and
                                  across the Middle East and North Africa, we
                                  launched a section for{" "}
                                  <Link
                                    to="inspiration/Destination%20Weddings?id=21"
                                    target="_blank"
                                  >
                                    <strong>Destination Weddings</strong>
                                  </Link>{" "}
                                  that features &nbsp;- from Lake Como to
                                  Limassol, providing tips and advice on various
                                  aspects of planning a destination wedding, and{" "}
                                  . Make sure to check it out.&nbsp;
                                </p>
                              </div>
                            </div>
                          </div>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
